"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentConfirmation = PaymentConfirmation;
exports.PaymentConfirmationV3 = PaymentConfirmationV3;
exports.applyCouponCodeApi = applyCouponCodeApi;
exports.createOrder = void 0;
exports.deleteCouponCodeApi = deleteCouponCodeApi;
exports.getPaymentMethod = getPaymentMethod;
exports.initiatePayment = initiatePayment;
exports.initiatePaymentV3 = initiatePaymentV3;
exports.initiatePaymentV4 = initiatePaymentV4;
exports.initiatePaymentV5 = initiatePaymentV5;
exports.listOfCouponCodeApi = listOfCouponCodeApi;
exports.setPaymentMethodApi = setPaymentMethodApi;
exports.setPaymentMode = void 0;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import { apiCall } from '../../../common/api/api';

function applyCouponCodeApi(requestParams, tokenData) {
  const {
    userId = '',
    couponCode = '',
    cartId,
    zones,
    ...rest
  } = requestParams || {};
  const queryString = (0, _utils.getQuery)(rest);
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.COUPONS_ACTION)(cartId)}${queryString}`;
  // const query = getQuery(requestParams);
  // const apiEndPoint = BASE_URL + APPLY_COUPON_CODE_URL + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = {
    coupon_code: couponCode,
    zones
  };
  options.method = _ApiConst.API_PARAMS.PUT;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({
  //   apiEndPoint,
  //   requestType: API_PARAMS.PUT
  // });
}
function deleteCouponCodeApi(requestParams, tokenData) {
  const {
    cartId,
    page,
    userId,
    cartType,
    ...rest
  } = requestParams;
  const queryString = (0, _utils.getQuery)({
    page,
    cart_type: cartType,
    ...rest
  });
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.COUPONS_ACTION)(cartId)}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.DELETE;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({
  //   apiEndPoint,
  //   requestType: API_PARAMS.DELETE
  // });
}
function listOfCouponCodeApi(requestParams, tokenData) {
  const {
    items,
    total,
    userId,
    userEmail,
    userMobile,
    shipments,
    ...rest
  } = requestParams;
  const query = (0, _utils.getQuery)(rest);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.LIST_OF_COUPON_CODE_URL + query;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = {
    items,
    total,
    shipments,
    userEmail,
    userMobile
  };
  options.method = _ApiConst.API_PARAMS.POST;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });

  // return apiCall({
  //   apiEndPoint,
  //   requestType: API_PARAMS.GET
  // });
}
function initiatePayment(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.EPHARMACY_INITIATE_PAYMENT}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}
function initiatePaymentV3(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.EPHARMACY_INITIATE_PAYMENT_V3}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}
function initiatePaymentV5(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.EPHARMACY_INITIATE_PAYMENT_V5}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}
function initiatePaymentV4(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.EPHARMACY_INITIATE_PAYMENT_V4}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function PaymentConfirmation(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.EPHARMACY_PAYMENT_CONFIRMATION}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.POST, apiPostData: params });
}
function PaymentConfirmationV3(requestParams, tokenData) {
  const {
    data
  } = requestParams;
  const {
    params
  } = data;
  const apiEndPoint = `${_ApiConst.BASE_URL}${_ApiConst.EPHARMACY_PAYMENT_CONFIRMATION_V3}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = params;
  options.method = _ApiConst.API_PARAMS.POST;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getPaymentMethod(params, tokenData) {
  const {
    platform,
    businessUnitCode,
    userId
  } = params;
  let queryString = `?platform=${platform}&businessUnitCode=${businessUnitCode}`;
  if (userId) {
    queryString = queryString + `&userId=${userId}`;
  }
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.PAYMENT_OPTIONS + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
function setPaymentMethodApi(params, tokenData) {
  const {
    addressId,
    paymentMethod
  } = params;
  const generateParam = {
    deliveryAddress: addressId,
    paymentMethodType: paymentMethod,
    ...params
  };
  const queryString = (0, _utils.getQuery)(generateParam);
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.SET_PAYMENT_METHOD_URL + queryString;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
  // return apiCall({ apiEndPoint, requestType: API_PARAMS.GET });
}
const createOrder = (requestParams = {}, tokenData) => {
  const {
    cartId,
    userId,
    ...rest
  } = requestParams || {};
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.CREATE_ORDER)(cartId)}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = rest;
  options.method = _ApiConst.API_PARAMS.POST;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.createOrder = createOrder;
const setPaymentMode = (requestParams = {}, tokenData) => {
  const {
    cartId,
    userId,
    page,
    ...rest
  } = requestParams || {};
  const queryString = (0, _utils.getQuery)({
    page
  });
  const apiEndPoint = `${_ApiConst.BASE_URL}${(0, _ApiConst.SET_PAYMENT_MODE)(cartId)}${queryString}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.body = rest;
  options.method = _ApiConst.API_PARAMS.PUT;
  if (userId) {
    return (0, _genericFetch.default)({
      apiEndPoint,
      options: {
        ...options,
        headers: {
          ...(options === null || options === void 0 ? void 0 : options.headers),
          'x-user-vcpId': userId
        }
      }
    });
  }
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
};
exports.setPaymentMode = setPaymentMode;